import { memo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import {
    Avatar,
    Button,
    ButtonGroup,
    Dropdown,
    DropdownItem,
    Header,
    HeaderBrand,
    HeaderWidgets,
    ToggleButton,
} from '@flixbus/honeycomb-react';
import { Icon, IconLogout, IconProfile } from '@flixbus/honeycomb-icons-react';
import { useTranslation } from 'react-i18next';
import { login, logout } from '../../helpers/auth';
import LanguageSwitcher from '../languageSwitcher/LanguageSwitcher';

const ProfileAvatar = () => (
    <Avatar>
        <Icon InlineIcon={IconProfile} size="cover" fillCanvas aria-hidden="true" />
    </Avatar>
);

const UserMenu = ({ account }) => {
    const { t } = useTranslation();
    const [expanded, setExpanded] = useState(false);

    if (!account) {
        return (
            <Button noWrap appearance="link" onClick={login}>
                <ProfileAvatar />
                {t('buttons.login')}
            </Button>
        );
    }

    return (
        <Dropdown
            xPosition="left"
            onToggle={setExpanded}
            links={[
                <DropdownItem key="logout" Elem="button" InlineIcon={IconLogout} onClick={logout}>
                    {t('buttons.logout')}
                </DropdownItem>,
            ]}
        >
            <ToggleButton noWrap iconSize="M" appearance="link" aria-expanded={expanded} data-dd-privacy="mask">
                <ProfileAvatar />
                {account.name || ''}
            </ToggleButton>
        </Dropdown>
    );
};

const AppHeader = () => {
    const { t } = useTranslation();
    const { accounts } = useMsal();

    return (
        <Header
            fixed
            widgetSize="l"
            brand={
                <HeaderBrand
                    alt="Flixbus"
                    href="/"
                    src="https://honeycomb-assets.hive.flixbus.com/honeycomb-logos-static/1.0.1/svg/flixbus-white.svg"
                    width="126"
                    height="24"
                    RouterLink={NavLink}
                />
            }
            widgets={
                <HeaderWidgets>
                    <ButtonGroup orientation="horizontal">
                        <LanguageSwitcher />
                        <nav aria-label={t('titles.userMenu')}>
                            <UserMenu account={accounts[0]} />
                        </nav>
                    </ButtonGroup>
                </HeaderWidgets>
            }
        />
    );
};

export default memo(AppHeader);
